<template>
  <div class="traceability-subheader">
    <div
      slot="filter-labels"
      class="search-title"
    >
      <div>
        <svg-loader
          src="/static/images/icons/icon-arrow-left.svg"
          @click.native="$router.push('/dashboard')"
        />
        <md-tooltip>Voltar ao dashboard</md-tooltip>
      </div>

      <h2>
        <span class="search">{{ title }}</span>
        <span
          v-for="(label, index) in filterLabels"
          :key="label"
        >
          <span class="filter-labels">{{ label }}</span>
          <span v-if="index + 1 < filterLabels.length">,</span>
        </span>
      </h2>
    </div>
  </div>
</template>

<script>
import { convertDateToLabel } from '@/utils/build-filter-labels'
import SubHeader from '@/components/common/SubHeader'
import strings from '@/strings'
import Moment from 'moment'
import { TRACEABILITY_SEARCH_DATE, TRACEABILITY_SEARCH_STATUS } from '@/enums'

export default {
  name: 'TraceabilitySubheader',
  components: {
    subheader: SubHeader,
  },
  props: {
    title: {
      type: String,
    },
  },
  data: () => ({
    filterLabels: [],
    searchType: strings.traceabilitySearchType,
  }),
  computed: {
    today: function () {
      return Moment(new Date()).format('DD/MM/YYYY')
    },
  },
  watch: {
    $route(to, from) {
      this.buildFilterLabel()
    },
  },
  created() {
    this.buildFilterLabel()
  },
  methods: {
    pushToFilter() {
      this.$router.push({
        path: '/traceability/filter',
        query: {
          q: this.$route.query.q,
          typeOfSearch: this.$route.query.typeOfSearch,
          startDate: this.$route.query.startDate,
          endDate: this.$route.query.endDate,
          status: this.$route.query.status,
        },
      })
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Rastreabilidade',
        action: 'Ir para o filtro',
      })
    },
    buildFilterLabel() {
      this.filterLabels = []

      if (this.$route.query.typeOfSearch === TRACEABILITY_SEARCH_DATE) {
        // DATE MODE
        this.filterLabels.push(
          convertDateToLabel(
            this.filterInitialStartDate(),
            this.filterInitialEndDate(),
            this.today
          )
        )
      } else if (this.$route.query.typeOfSearch === TRACEABILITY_SEARCH_STATUS) {
        // STATUS MODE
        this.filterLabels.push(
          'Status ' +
            this.$strings.traceabilityStatus[this.$route.query.status].translated
        )
      } else {
        // QUERY MODE
        let param = this.$route.query.typeOfSearch
        this.filterLabels.push(
          this.searchType[param].translated + ' ' + this.$route.query.q
        )
      }

      if (Object.keys(this.$route.query).length === 1) {
        this.filterLabels.push('todas')
      }
    },
    filterInitialStartDate() {
      if (this.$route.query.startDate || this.$route.query.startDate === '') {
        return this.$route.query.startDate
      } else {
        return this.today
      }
    },
    filterInitialEndDate() {
      if (this.$route.query.endDate || this.$route.query.endDate === '') {
        return this.$route.query.endDate
      } else {
        return this.today
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.traceability-subheader {
  margin: auto;
  width: 100%;
  margin-bottom: 16px;

  .filter-labels {
    font-weight: 400;
    font-size: 23px;
    color: #7f1a54;
  }

  .search {
    color: #6d6d6d;
    font-weight: 700;
    font-size: 23px;
    margin-left: 24px;
  }
}
</style>
